import React from "react";

const LoadingSpinner = ({ color, size }) => {
  return (
    <div className={`lds-ring  ${color} ${size} `}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default LoadingSpinner;
